'use strict';

var Typeahead = require('./Typeahead.react');

module.exports = Typeahead;


//////////////////
// WEBPACK FOOTER
// ./~/mesosphere-react-typeahead/lib/index.js
// module id = 1905
// module chunks = 2